import { render } from "./ViewEmployeeAttendanceSummary.vue?vue&type=template&id=8dca2cf2&scoped=true"
import script from "./ViewEmployeeAttendanceSummary.vue?vue&type=script&lang=js"
export * from "./ViewEmployeeAttendanceSummary.vue?vue&type=script&lang=js"

import "./ViewEmployeeAttendanceSummary.vue?vue&type=style&index=0&id=8dca2cf2&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dca2cf2"]])

export default __exports__